<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="request && request.id">
      {{ 'REQUESTS.REQUEST_FORM.EDIT' | translate }}
      <app-user-states [modelType]="laravelModels.ENQUIRY" [modelId]="request.id"></app-user-states>
    </span>
    <span *ngIf="!request || !request.id">{{ 'REQUESTS.REQUEST_FORM.ADD' | translate }}</span>

    <app-sale-button
      *ngIf="request.sale"
      targetBlank="true"
      [link]="['/sales/view']"
      [params]="{ id: request.sale.id }"
    >
    </app-sale-button>
  </h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <div *ngIf="rawDataToggle">
    <ngx-json-viewer [json]="request.raw_data"></ngx-json-viewer>
  </div>

  <form id="hotel-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-12">
        <div class="modal-section-title">Internal Title</div>
      </div>
      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.COMPANY' | translate }}
        </div>
        <div class="value">
          {{ request?.company?.shortName || '-' }}
        </div>
      </div>
      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.COMPANY_WEBSITE' | translate }}
        </div>
        <div class="value">
          {{ request?.company_website?.name || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.TYPE' | translate }}
        </div>
        <div class="value">
          {{ request?.type || '-' }}
        </div>
      </div>
      <div class="col-sm-12">
        <div class="modal-section-title mt-2">External Title</div>
      </div>

      <div class="col-sm-4">
        <app-event-select [parentFormGroup]="form"></app-event-select>
      </div>

      <div class="col-sm-4">
        <app-event-group-select [parentFormGroup]="form"></app-event-group-select>
      </div>

      <div class="col-sm-4">
        <app-hotel-select [parentFormGroup]="form"></app-hotel-select>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.COMPANY_NAME' | translate }}
        </div>
        <div class="value">
          {{ request?.company_name || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.FIRST_NAME' | translate }}
        </div>
        <div class="value">
          {{ request?.first_name || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.LAST_NAME' | translate }}
        </div>
        <div class="value">
          {{ request?.last_name || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.EMAIL' | translate }}
        </div>
        <div class="value">
          {{ request?.email || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.PHONE' | translate }}
        </div>
        <div class="value">
          {{ request?.phone || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.HOTEL_STARS' | translate }}
        </div>
        <div class="value">
          {{ request?.hotel_stars || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.BUDGET' | translate }}
        </div>
        <div class="value">
          {{ request?.budget || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.REQUIREMENTS' | translate }}
        </div>
        <div class="value">
          {{ request?.requirements || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="title">
          {{ 'REQUESTS.REQUEST_FORM.NOTES' | translate }}
        </div>
        <div class="value">
          {{ request?.notes || '-' }}
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group client-with-finder-form-group">
          <app-client-select
            [parentFormGroup]="form"
            *ngIf="clientSelectShow"
            class="client-select"
          ></app-client-select>
          <button
            *ngIf="form.get('client_id').value"
            [ngbTooltip]="'REQUESTS.REQUEST_FORM.EDIT_CLIENT' | translate"
            container="body"
            type="button"
            (click)="editClient(form.get('client_id').value)"
            class="btn btn-primary btn-client-edit"
          >
            <i class="fal fa-pencil"></i>
          </button>
          <button
            [ngbTooltip]="'REQUESTS.REQUEST_FORM.CLIENTS_FINDER' | translate"
            container="body"
            type="button"
            (click)="openClientFinder()"
            class="btn btn-info btn-client-finder"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="modal-section-title mt-2">Rooms Title</div>
      </div>

      <div class="col-sm-12">
        <kendo-grid [data]="request?.rooms">
          <kendo-grid-column [width]="50" field="id" title="{{ 'REQUESTS.REQUEST_FORM.ID' | translate }}">
          </kendo-grid-column>

          <kendo-grid-column field="type.value" title="{{ 'REQUESTS.REQUEST_FORM.ROOM_TYPE' | translate }}">
          </kendo-grid-column>

          <kendo-grid-column field="meal_plan.value" title="{{ 'REQUESTS.REQUEST_FORM.MEAL_PLAN' | translate }}">
          </kendo-grid-column>

          <kendo-grid-column field="check_in" title="{{ 'REQUESTS.REQUEST_FORM.CHECK_IN' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.check_in | date : env.pipeDateFormat }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="check_out" title="{{ 'REQUESTS.REQUEST_FORM.CHECK_OUT' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.check_out | date : env.pipeDateFormat }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="count" title="{{ 'REQUESTS.REQUEST_FORM.COUNT' | translate }}"></kendo-grid-column>

          <kendo-grid-column field="hotel_stars" title="{{ 'REQUESTS.REQUEST_FORM.HOTEL_STARS' | translate }}">
          </kendo-grid-column>

          <kendo-grid-column field="budget" title="{{ 'REQUESTS.REQUEST_FORM.BUDGET' | translate }}">
          </kendo-grid-column>
        </kendo-grid>
      </div>

      <div class="col-sm-12">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input type="checkbox" class="custom-control-input" formControlName="finished" id="request-form-finished" />
          <label class="custom-control-label" for="request-form-finished">
            {{ 'REQUESTS.REQUEST_FORM.FINISHED' | translate }}
          </label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button class="btn btn-primary btn-success btn-xs me-auto" (click)="toggleRawData()">
    <ng-container *ngIf="rawDataToggle">
      {{ 'REQUESTS.REQUEST_FORM.RAW_DATA_HIDE_BUTTON' | translate }}
    </ng-container>
    <ng-container *ngIf="!rawDataToggle">
      {{ 'REQUESTS.REQUEST_FORM.RAW_DATA_SHOW_BUTTON' | translate }}
    </ng-container>
  </button>
  <button type="submit" class="btn btn-outline-dark btn-xs" form="hotel-form" [disabled]="form.invalid">
    {{ 'REQUESTS.REQUEST_FORM.SAVE' | translate }}
  </button>
</div>
